import React from "react";
import Container from "../ui/Container";
import EntryContent from "../ui/EntryContent";
import EyebrowTitle from "../ui/EyebrowTitle";
import Section from "../../components/ui/Section";

import Rollups from "./technology/Rollups";
import VirtualMachine from "./technology/VirtualMachine";

const Technology = ({ data }) => {
  const { badge, headline, rollups, vmBlock } = data;
  return (
    <Section className="pb-0">
      <Container>
        <div className="mx-auto mb-section flex max-w-screen-md flex-col items-center text-center">
          <EyebrowTitle label={badge} as="p" />
          <EntryContent>
            <h2>{headline}</h2>
          </EntryContent>
        </div>
        <div className="flex flex-col gap-8 sm:gap-16">
          <VirtualMachine data={vmBlock} />
          <Rollups data={rollups} />
        </div>
      </Container>
    </Section>
  );
};

export default Technology;
